// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment_deposit".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { depositLinkSourceValues, depositStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "appointment_deposit" table (1:1 with a DB row, on the wire). */
export const appointmentDepositAtomSchema = z.object({
    id: z.string(),
    appointmentId: z.string(),
    organizationId: z.string(),
    amountCents: z.number(),
    refundedAmountCents: z.number(),
    currency: z.string(),
    status: z.enum(depositStatusValues),
    stripeCheckoutSessionId: z.string().nullable(),
    stripePaymentIntentId: z.string().nullable(),
    stripeConnectedAccountId: z.string(),
    checkoutUrl: z.string().nullable(),
    expiresAt: z.string().datetime(),
    paidAt: z.string().datetime().nullable(),
    refundedAt: z.string().datetime().nullable(),
    attempt: z.number(),
    source: z.enum(depositLinkSourceValues).nullable(),
    createdByUserId: z.string().nullable(),
    leadId: z.string().nullable(),
    conversationId: z.string().nullable(),
    revokedAt: z.string().datetime().nullable(),
    revokedByUserId: z.string().nullable(),
    revokedSource: z.enum(depositLinkSourceValues).nullable(),
    lastSentAt: z.string().datetime().nullable(),
    lastSentMessageId: z.string().nullable(),
    lastSentByUserId: z.string().nullable(),
    sendCount: z.number(),
    receiptEmailRequested: z.boolean(),
    receiptSentAt: z.string().datetime().nullable(),
    receiptUrl: z.string().nullable(),
    stripeChargeId: z.string().nullable(),
    reviewReason: z.string().nullable(),
    reviewRequiredAt: z.string().datetime().nullable(),
    failureReason: z.string().nullable(),
    paymentProcessingAt: z.string().datetime().nullable(),
    priorPencilledIn: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=appointmentDeposit.js.map